'use client'

import { useState } from "react"
import { useTranslations } from "@dustin-web/microsite-components/src/hooks"
import Icon from "@dustin-web/microsite-components/src/icon"
import Drawer from "@dustin-web/microsite-components/src/drawer"
import TagFilter from "./tag-filter"

type Props = {
  onTagClick: (arg0: string) => void
  clearTag: () => void
  selectedTag: string | undefined
  tags: { label: string, value: string }[]
}

export const TagDrawer = ({ selectedTag, tags, onTagClick, clearTag }: Props) => {
  const { translate } = useTranslations()
  const [showMobileTagFilter, setShowMobileTagFilter] = useState(false)

  return (
    <>
      <div className="col-12 d-flex justify-content-end">
        <button onClick={() => setShowMobileTagFilter(!showMobileTagFilter)}>
          <Icon name="settings" className="i-20 u-mr-8" />
          {translate('Tags_Filter')}
        </button>
      </div>
      <Drawer
        visible={showMobileTagFilter}
        onClose={() => setShowMobileTagFilter(false)}
        className="u-px-0 u-pb-0">
        <TagFilter
          tags={tags}
          onTagClick={value => onTagClick(value)}
          selectedTag={selectedTag || ''}
          showAll={true}
        />
        <div className="u-sticky-bottom u-bg-white u-px-16 u-py-16 d-flex">
          <button
            className="c-btn u-mb-0 u-mr-8 u-w-shrink"
            disabled={!selectedTag?.length}
            onClick={() => {
              clearTag()
            }}>
            {translate('MobileClearFilterLabel')}
          </button>

          <button
            className="c-btn c-btn--primary u-flex-1 u-mb-0"
            onClick={() => {
              setShowMobileTagFilter(false)
            }}>
            {selectedTag
              ? translate('MobileCloseAndShowFilterLabel')
              : translate('MobileCloseLabel')}
          </button>
        </div>
      </Drawer>
    </>
  )
}
